'use client';

import Link from 'next/link';
import { ArrowRight, Users } from 'lucide-react';

import { useUser } from '@kit/supabase/hooks/use-user';
import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

import { useBrand } from '~/components/brand-provider';
import pathsConfig from '~/config/paths.config';
import { BRAND_CONFIG } from '~/lib/brand';

export function HomepageCTA() {
  const { data: user } = useUser();
  const brand = useBrand();
  const brandName = BRAND_CONFIG[brand].name;

  if (user) {
    return (
      <div className="flex justify-center">
        <Button asChild variant="default" size="lg">
          <Link href={pathsConfig.app.home}>
            <ArrowRight className="mr-2 h-5 w-5" />
            <Trans i18nKey="marketing:home.cta.access" values={{ brandName }} />
          </Link>
        </Button>
      </div>
    );
  }

  if (brand === 'ballee') {
    return (
      <div className="flex justify-center gap-4">
        <Button asChild variant="outline" size="lg">
          <Link href={pathsConfig.auth.signIn}>
            <Trans i18nKey="marketing:home.cta.signIn" />
          </Link>
        </Button>
        <Button asChild variant="default" size="lg">
          <Link href={pathsConfig.auth.signUp}>
            <Users className="mr-2 h-5 w-5" />
            <Trans i18nKey="marketing:home.cta.joinCommunity" />
          </Link>
        </Button>
      </div>
    );
  }

  // Flow is the B2B platform sold to production agencies (dancers sign up on
  // ballee.co, not here). The primary CTA is a buyer path — book a demo — not
  // the old dancer self-serve register. Sign In stays for existing cohort users.
  return (
    <div className="flex justify-center gap-4">
      <Button asChild variant="outline" size="lg">
        <Link href={pathsConfig.auth.signIn}>
          <Trans i18nKey="marketing:home.cta.signIn" />
        </Link>
      </Button>
      <Button asChild variant="default" size="lg">
        <Link href="/contact">
          <ArrowRight className="mr-2 h-5 w-5" />
          <Trans i18nKey="marketing:home.cta.bookDemo" />
        </Link>
      </Button>
    </div>
  );
}
